import { lazy } from 'react';

const EditTopicsModal = lazy(() => import('./components/EditTopicsModal'));
const MentorQuestionModal = lazy(() =>
  import('./components/MentorQuestionModal'),
);

export default {
  EDIT_TOPICS_MODAL: EditTopicsModal,
  MENTOR_QUESTION_MODAL: MentorQuestionModal,
};
